(function () {
  'use strict';

  /* @ngdoc object
   * @name histExpurgo
   * @description
   *
   */
  angular
    .module('histExpurgo', [
      'ui.router',
      'angularMoment',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'pascalprecht.translate',
      'ConstantVfiltroModule',
      'VtabelaModule',
      'AlertasModule'
    ])
    .factory('HistExpurgo',
      Restangular => Restangular.service('/expurgo/expurgos'));
}());

